/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter, applyFilters } from '@wordpress/hooks';
import {
	RangeControl,
	ToggleControl,
	TextControl,
} from '@wordpress/components';

/**
 * Inner dependencies.
 */
import Accordion from '../../../components/Accordion';
import AdvanceQueryControls from '../../../components/AdvanceQueryControls';
import BlockLayouts from '../../../components/block-layouts';
import blockInfo from '../constants';
const { hookPrefix, layouts } = blockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-content`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content`,
	( content, props ) => {
		const { attributes, setAttributes } = props;
		const { displayPostContent, excerptLength, displayPostLink } = attributes;

		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion
					tabs={ [
						{
							name: 'posts',
							initialOpen: true,
							label: () => {
								return __( 'Posts' );
							},
							cb: () => {
								return (
									<>
										{ applyFilters( `gutenify--${ hookPrefix }--inspector--tab-content--posts`, [], props ) }
										<ToggleControl
											label={ __( 'Show content' ) }
											help={
												displayPostContent
													? __( 'Content showing' )
													: __( 'Content hidden' )
											}
											checked={ displayPostContent }
											onChange={ () => {
												setAttributes( {
													displayPostContent: ! displayPostContent,
												} );
											} }
										/>
										{ displayPostContent && (
											<>
												<TextControl
													value={ excerptLength }
													onChange={ ( val ) => {
														setAttributes( { excerptLength: val } );
													} }
													type="number"
													min="0"
													label={ __( 'Excerpt Length' ) }
													help={ __( 'Number of words in content' ) }
												/>

												<ToggleControl
													label={ __( 'Show Read more link' ) }
													help={
														displayPostLink
															? __( 'Read more link showing' )
															: __( 'Read more link hidden' )
													}
													checked={ displayPostLink }
													onChange={ () => {
														setAttributes( {
															displayPostLink: ! displayPostLink,
														} );
													} }
												/>
											</>
										) }
									</>
								);
							},
						},
					] }
				/>
			</Fragment>,
		];
	}
);

addFilter( `gutenify--${ hookPrefix }--inspector--tab-content--posts`, `gutenify--${ hookPrefix }--inspector--tab-content--posts--post-layout`, ( content, props ) => {
	const { attributes, setAttributes, updateInnerBlocks } = props;
	const { layout } = attributes;
	return [ ...content, <Fragment key={ `gutenify--${ hookPrefix }--inspector--tab-content--posts--post-layout` }>
		<BlockLayouts label={ __( 'Post Layout' ) } layouts={ layouts } value={ layout } blockName={ hookPrefix } onChange={ ( val ) => {
			const data = {
				layout: val.name,
				socialIconAlign: val.socialIconAlign,
				imageAlign: val.imageAlign,
				titleAlign: val.titleAlign,
			};
			setAttributes( data );
			updateInnerBlocks( val );
		} } />
	</Fragment> ];
} );

addFilter( `gutenify--${ hookPrefix }--inspector--tab-content--posts`, `gutenify--${ hookPrefix }--inspector--tab-content--posts--advance-query-controls`, ( content, props ) => {
	const { attributes, setAttributes } = props;
	const { query } = attributes;
	return [ ...content, <Fragment key={ `gutenify--${ hookPrefix }--inspector--tab-content--posts--advance-query-controls` }>
		<AdvanceQueryControls
			query={ query }
			postTypes={ [ 'post' ] }
			onChange={ ( val ) => {
				setAttributes( {
					query: { ...val },
				} );
			} }
			{ ...props }
		/>
	</Fragment> ];
} );

addFilter( `gutenify--${ hookPrefix }--inspector--tab-content--posts`, `gutenify--${ hookPrefix }--inspector--tab-content--posts--columns`, ( content, props ) => {
	const { attributes, setAttributes } = props;
	const { columns } = attributes;
	return [ ...content, <Fragment key={ `gutenify--${ hookPrefix }--inspector--tab-content--posts--columns` }>
		<RangeControl
			value={ columns }
			label={ __( 'Columns' ) }
			min={ 1 }
			max={ applyFilters( `gutenify--${ hookPrefix }--max-columns`, 3 ) }
			step={ 1 }
			onChange={ ( value ) => {
				setAttributes( { columns: value } );
			} }
		/>
	</Fragment> ];
} );
